export default {
      id: "tools-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#tools",
      toString: function () {
        return this.url;
      }
    }